import { options } from './options';
import { buildIntelligentPrompt, validatePromptQuality } from './promptBuilder';

export const canGenerateFaceSwap = ({ promptText, selectedOptions, mainTab, image }) => {
  const hasPrompt = promptText.trim().length > 0;
  const hasSelectedOptions = Object.values(selectedOptions).some(value => value && value !== '');

  if (mainTab === 'image-to-image') {
    return (hasPrompt || hasSelectedOptions) && image;
  }

  return hasPrompt || hasSelectedOptions;
};

export const getRandomSelectedOptions = () => {
  const newSelectedOptions = {};

  options.forEach(category => {
    category.children.forEach(child => {
      const availableOptions = child.options.filter(opt => opt.key !== 'default');
      if (availableOptions.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableOptions.length);
        newSelectedOptions[child.key] = availableOptions[randomIndex].key;
      }
    });
  });

  return newSelectedOptions;
};

export const buildCombinedPrompt = ({ selectedOptions, promptText, mainTab }) => {
  const intelligentPrompt = buildIntelligentPrompt(selectedOptions, promptText, mainTab);

  const validation = validatePromptQuality(intelligentPrompt);

  if (!validation.isValid && process.env.NODE_ENV === 'development') {
    console.warn('提示词质量警告:', validation.issues);
    console.log('改进建议:', validation.suggestions);
    console.log('质量评分:', validation.score);
  }

  return intelligentPrompt;
};

export const handleImageUploadChange = ({
  event,
  setImageFile,
  setImage,
  setShowUploadErrorModal
}) => {
  if (!event.target.files || !event.target.files[0]) {
    return;
  }

  const file = event.target.files[0];
  const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const okType = allowed.includes(file.type);
  const okSize = file.size <= 10 * 1024 * 1024;

  if (!okType || !okSize) {
    setShowUploadErrorModal(true);
    return;
  }

  setImageFile(file);
  const reader = new FileReader();
  reader.onload = (loadEvent) => {
    setImage(loadEvent.target.result);
  };
  reader.readAsDataURL(file);
};

